<template>
  <div class="table5">
    <el-table :data="list" height="850" style="width: 100%" ref="table" @sort-change='sortChange'>
      <el-table-column prop="" label="基金">
        <template slot-scope="scope">
          <div style="font-size: 15px; color: #333333">
            {{ scope.row.ths_bond_short_name_bond }}
          </div>
          <div style="font-size: 13px; color: #999999">
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="latest" label="现价" align="center" sortable='custom'>
        <template slot-scope="scope">
          <div style="font-size: 15px" :class="{ colorRed: scope.row.swing && scope.row.swing > 0, colorGreen:  scope.row.swing && scope.row.swing < 0,}">{{ scope.row.latest || '--'}}</div>
          <div style="font-size: 10px" :class="{ colorRed:  scope.row.swing && scope.row.swing > 0, colorGreen:  scope.row.swing && scope.row.swing < 0,}">{{ scope.row.swing || '--'}} <i v-if=" scope.row.swing">%</i></div>
        </template>
      </el-table-column>
      <el-table-column prop="ths_remain_duration_y_bond" label="剩余年限" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.ths_remain_duration_y_bond || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="pre_tax_rate_of_return" label="税前收益率" align="center" sortable='custom'>
        <template slot-scope="scope">
          <div>{{ scope.row.pre_tax_rate_of_return || '--'}}</div>
          <div>{{ scope.row.pre_tax_rate_of_return_value || '--' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="成交(万元)" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.amount || '--'}}
        </template>
      </el-table-column>
      <el-table-column prop="ths_nominal_interest_current_bond" label="票息" align="center" sortable='custom'>
        <template slot-scope="scope">
          {{scope.row.ths_nominal_interest_current_bond || '--'}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {bondDataList} from '../../../http/index.js'
export default {
  props:{
    
  },
  data() {
    return {
      list:[],
      page:1,
      page_number:20,
      sortObj:{
        
      },

    };
  },

  mounted() {
    this.getlist()
    // 获取需要绑定的table
    this.dom = this.$refs.table.bodyWrapper
    this.dom.addEventListener('scroll', () => {
        // 滚动距离
        let scrollTop = this.dom.scrollTop
        let canshu = 350 * this.page
        console.log(canshu);
        console.log(scrollTop);
        if(scrollTop > canshu){
          this.getMore()
        }
    })
  },
  methods:{
    getMore() {
      this.page++
      this.getlist()
    },
    getlist(){
      let obj = this.sortObj
      let params = Object.assign({},{page:this.page,page_number:this.page_number,type:'债券'},obj)
      bondDataList(params).then((res)=>{
        if(this.page == 1){
          this.list = res.data.list
        }else{
          this.list = this.list.concat(res.data.list)
        }
      })
    },
    sortChange(a){
      this.page = 1
      this.list = []
      let canshu1 = a.prop
      let canshu2 
      if(a.order == 'ascending'){
        canshu2 = 'asc'
      }else if(a.order == 'descending'){
        canshu2 = 'desc'
      }else{
        canshu2 = null
      }
      if(canshu2 == null){
        this.sortObj = {}
        this.getlist()
      }else{
        let obj = {sort: `${canshu1} ${canshu2}`}
        this.sortObj = obj
        this.getlist()
      }
    }
  }
};
</script>

<style scoped>
.table5 {
  min-width: 1427px;
  position: relative;
}

th img {
  width: 8px;
  height: 15px;
  vertical-align: middle;
  margin-left: 6px;
}
td img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.ssd {
  background-color: #539cff;
  font-size: 10px;
  height: 13px;
  line-height: 13px;
  border-radius: 3px;
  color: #fefefe;
  padding: 0 5px;
}

i {
  font-style: normal;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
.fontSize16 {
  font-size: 16px;
}
.colorRed {
  color: #fd4c4c;
}
.colorBlue {
  color: #4372ba;
}
.colorGreen {
  color: #41b357;
}
.BackColorGreen {
  background-color: #41b357;
}
.BackColorBlue {
  background-color: #4372ba;
}
.table5 /deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
.table5 /deep/ .cell {
  padding: 0;
}
.table5 /deep/ .el-table th.el-table__cell > .cell {
  padding: 0;
}
</style>